// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:35:23

export default {
  "id": "zombie-redemption",
  "slug": "zombie-redemption",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60fe1469f0cd4b4a8de22879939d5db7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60fe1469f0cd4b4a8de22879939d5db7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Zombie Redemption",
      "description": "Zombie Redemption is an action-survival game set in a world where a failed experiment has turned most of humanity into zombies. Players earn gold by defeating zombies, which can be used to unlock stronger weapons. However, zombies also attack, making quick reflexes and strategic thinking essential for survival. Combining elements of strategy, action, and survival, this game offers an unforgettable adventure in the fight to save the world.",
      "instructions": "W, A, S, D and mouse.",
      "genres": [
        "Battle"
      ],
      "tags": [
        "war",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "僵尸救赎",
      "description": "僵尸救赎是一款动作生存游戏，设定在一个失败的实验将大部分人类变成僵尸的世界。玩家通过击败僵尸获得金币，可以用金币解锁更强大的武器。然而，僵尸也会发起攻击，这使得快速的反应力和战略思考对于生存至关重要。结合策略、动作和生存元素，这款游戏在拯救世界的战斗中提供了一段难忘的冒险。",
      "instructions": "W, A, S, D 和鼠标。",
      "genres": [
        "战斗"
      ],
      "tags": [
        "战争",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "僵屍贖罪",
      "description": "僵尸贖罪是一款設定在失敗實驗將大多數人類變成僵屍的世界中的動作求生遊戲。玩家透過擊敗僵屍獲得黃金，可用來解鎖更強大的武器。然而，僵屍也會攻擊，讓快速反應和策略思考成為生存的關鍵。結合策略、動作和求生元素，這款遊戲提供了一場難忘的冒險，在拯救世界的奮戰中。",
      "instructions": "W、A、S、D及滑鼠。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "戰爭",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "僵尸救赎",
      "description": "僵尸贖罪是一款設置在失敗實驗將大部分人類變成僵屍的世界中的動作生存遊戲。玩家通過擊敗僵屍來獲得黃金，可用於解鎖更強大的武器。然而，僵屍也會攻擊，因此敏捷的反應和策略思考對於生存至關重要。結合策略、動作和生存元素，這款遊戲為玩家提供了一場難忘的世界拯救戰鬥冒險。",
      "instructions": "W、A、S、D 及滑鼠。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "戰爭",
        "僵屍"
      ]
    },
    "ja": {
      "title": "ゾンビ・リデンプション",
      "description": "ゾンビリデンポーションは、失敗した実験によって多くの人々がゾンビに変身した世界で展開されるアクション・サバイバルゲームです。プレイヤーはゾンビを倒してゴールドを稼ぎ、より強力な武器を解放するために使えます。しかし、ゾンビも攻撃してくるため、素早い反応と戦略的な思考が生き延びるために不可欠です。戦略、アクション、サバイバルの要素を組み合わせたこのゲームは、世界を救う戦いの中での忘れられない冒険を提供します。",
      "instructions": "W、A、S、Dとマウス。",
      "genres": [
        "バトル"
      ],
      "tags": [
        "戦争",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "좀비 구원",
      "description": "Zombie Redemption은 실험 실패로 인해 대부분의 인류가 죽은자가 되어버린 세상에서发生的 액션-생존 게임입니다. 플레이어는 죽은자를 물리치면 금을 얻어 더 강력한 무기를 해금할 수 있습니다. 하지만 죽은자들도 공격하기 때문에 빠른 반응과 전략적 사고가 생존에 필수적입니다. 전략, 액션, 생존 요소를 결합하여 이 게임은 세계를 구하기 위해 싸우는 기억에 남는 모험을 제공합니다.",
      "instructions": "W, A, S, D 및 마우스.",
      "genres": [
        "전투"
      ],
      "tags": [
        "전쟁",
        "좀비"
      ]
    },
    "fr": {
      "title": "Redemption des Zombies",
      "description": "Zombie Redemption est un jeu d'action-surnatural se déroulant dans un monde où un échec expérimental a transformé la plupart de l'humanité en zombies. Les joueurs gagnent de l'or en vainquant les zombies, que l'on peut utiliser pour déverrouiller des armes plus puissantes. Cependant, les zombies attaquent également, rendant les réflexes rapides et la pensée stratégique essentiels pour la survie. En combinant des éléments de stratégie, d'action et de survie, ce jeu propose une aventure inoubliable dans la lutte pour sauver le monde.",
      "instructions": "W, A, S, D et souris.",
      "genres": [
        "Bataille"
      ],
      "tags": [
        "Guerre",
        "zombie"
      ]
    }
  }
};
